import api from '@pray/shared/utils/api';

/**
 * Delete an impact report.
 *
 * @param {Object} params
 * @param {string} params.artistId - The artist UUID
 * @param {string} params.reportId - The report UUID to delete
 * @returns {Promise<Object>} The deleted report data
 */
export async function deleteImpactReport({ artistId, reportId }) {
  const url = `/web/studio/artists/${artistId}/analytics/revenue/reports/${reportId}`;
  const response = await api.executeDeleteRequest(url);
  return response.data.data;
}
